(() => {
  const sectionSelector = '[data-pil-coll-vins]';
  const controlSelector = '[data-filter="color"], input[data-filter="fmt"], input[data-filter="cep"]';

  const hasValue = (card, filter, value) => {
    const values = (card.getAttribute(`data-${filter}`) || '').trim().split(/\s+/);
    return values.includes(value);
  };

  const syncAvailability = (section) => {
    const cards = Array.from(section.querySelectorAll('.pil-cc'));
    section.querySelectorAll(controlSelector).forEach((control) => {
      const filter = control.getAttribute('data-filter');
      const value = control.getAttribute('data-value');
      const chip = control.matches('input') ? control.closest('.pil-aff-chip') : control;
      if (!chip || !filter || !value) return;

      const available = cards.some((card) => hasValue(card, filter, value));
      chip.hidden = !available;
      chip.style.display = available ? '' : 'none';
      chip.setAttribute('aria-hidden', available ? 'false' : 'true');
      if (!available && control.matches('input')) control.checked = false;
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll(sectionSelector).forEach(syncAvailability);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
